import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
} from "@angular/core";
import { MatCalendar } from "@angular/material/datepicker";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MatDateFormats,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import * as _moment from "moment";
//import { default as _rollupMoment } from 'moment';

//const moment = _rollupMoment || _moment;
const moment = _moment;
import { FormControl } from "@angular/forms";

export const MY_FORMATS = {
  parse: {
    dateInput: "MM/DD",
  },
  display: {
    dateInput: "MM/DD",
    monthYearLabel: "MMM",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

///** @title Datepicker with custom calendar header */
//@Component({
//  selector: 'datepicker-custom-header-example',
//  templateUrl: 'datepicker-custom-header-example.html',
//  changeDetection: ChangeDetectionStrategy.OnPush,
//  providers: [{
//    provide: DateAdapter,
//    useClass: MomentDateAdapter,
//    deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
//  }, { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
//})
//export class DatepickerCustomHeader {
//  customHeader = CustomHeader;
//  date = new FormControl(moment());

//}

/** Custom header component for datepicker. */
@Component({
  selector: "custom-header",
  styles: [
    `
      .custom-header {
        display: flex;
        align-items: center;
        padding: 0.5em;
      }

      .custom-header-label {
        flex: 1;
        height: 1em;
        font-weight: 500;
        text-align: center;
      }

      .custom-double-arrow .mat-icon {
        margin: -22%;
      }
    `,
  ],
  template: `
    <div class="custom-header">
      <button mat-icon-button (click)="previousClicked('month')">
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>
      <span class="custom-header-label">{{ periodLabel }}</span>
      <button mat-icon-button (click)="nextClicked('month')">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomHeader<D> implements OnDestroy {
  private _destroyed = new Subject<void>();

  constructor(
    private _calendar: MatCalendar<D>,
    private _dateAdapter: DateAdapter<D>,
    @Inject(MAT_DATE_FORMATS) private _dateFormats: MatDateFormats,
    cdr: ChangeDetectorRef
  ) {
    _calendar.stateChanges
      .pipe(takeUntil(this._destroyed))
      .subscribe(() => cdr.markForCheck());
  }

  ngOnDestroy() {
    this._destroyed.next();
    this._destroyed.complete();
  }

  get periodLabel() {
    let label = this._dateAdapter
      .format(
        this._calendar.activeDate,
        this._dateFormats.display.monthYearLabel
      )
      .toLocaleUpperCase();

    return label;
  }

  previousClicked(mode: any) {
    let month = this._dateAdapter.format(
      this._calendar.activeDate,
      this._dateFormats.display.monthYearLabel
    );
    console.log(month);
    if (month === "Mar") {
      this._calendar.activeDate = this._dateAdapter.addCalendarMonths(
        this._calendar.activeDate,
        -13
      );
    } else if (month === "Feb") {
      this._calendar.activeDate = this._dateAdapter.addCalendarMonths(
        this._calendar.activeDate,
        11
      );
    } else {
      this._calendar.activeDate = this._dateAdapter.addCalendarMonths(
        this._calendar.activeDate,
        -1
      );
    }
  }

  nextClicked(mode: any) {
    let year = this._dateAdapter.format(this._calendar.activeDate, "YYYY");
    let month = this._dateAdapter.format(
      this._calendar.activeDate,
      this._dateFormats.display.monthYearLabel
    );
    if (month === "Jan" && year == "2021") {
      this._calendar.activeDate = this._dateAdapter.addCalendarMonths(
        this._calendar.activeDate,
        -11
      );
    } else if (month === "Feb") {
      this._calendar.activeDate = this._dateAdapter.addCalendarMonths(
        this._calendar.activeDate,
        13
      );
    } else {
      this._calendar.activeDate = this._dateAdapter.addCalendarMonths(
        this._calendar.activeDate,
        1
      );
    }
  }
}
